import { readonly, ref } from 'vue';

const progress = ref(0);
const visible = ref(false);

let activeCount = 0;
let trickleTimer: ReturnType<typeof setInterval> | null = null;
let hideTimer: ReturnType<typeof setTimeout> | null = null;

function clearHideTimer() {
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
}

function stopTrickle() {
  if (trickleTimer) {
    clearInterval(trickleTimer);
    trickleTimer = null;
  }
}

function startTrickle() {
  stopTrickle();
  trickleTimer = setInterval(() => {
    if (progress.value < 90) {
      const increment = Math.random() * 8 + 2;
      progress.value = Math.min(90, progress.value + increment);
    }
  }, 350);
}

export function startRequestProgress() {
  clearHideTimer();
  activeCount += 1;

  if (activeCount === 1) {
    visible.value = true;
    progress.value = 0;
    requestAnimationFrame(() => {
      progress.value = 18;
    });
    startTrickle();
  }
}

export function finishRequestProgress() {
  activeCount = Math.max(0, activeCount - 1);

  if (activeCount > 0) {
    return;
  }

  stopTrickle();
  progress.value = 100;

  hideTimer = setTimeout(() => {
    visible.value = false;
    progress.value = 0;
    hideTimer = null;
  }, 220);
}

export function useRequestProgress() {
  return {
    progress: readonly(progress),
    visible: readonly(visible),
  };
}

export function resetRequestProgressForTests() {
  activeCount = 0;
  progress.value = 0;
  visible.value = false;
  stopTrickle();
  clearHideTimer();
}
